/** Standard Social Booster price on basic jobs (EUR). */
export const DEFAULT_SOCIAL_BOOSTER_PRICE = 1499;

/** Social Booster add-on price on Sourcing Agent jobs (EUR). */
export const DEFAULT_SOCIAL_BOOSTER_AGENT_ADDON_PRICE = 499;
